module.exports = __webpack_public_path__ + "img/offline-big.3a99aaf7.svg";